// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import Tips from './Tips';

import '../../styles/modal.css';
import '../../styles/tips.css';

export default class EmailTips extends Tips {

    renderContent = () => {
        return (<div className="modal-content modal-center">
            {this.state.stage === 0 ? <>
                <h1>Stax<div className="navigation-logo-dot" />ai can get your email attachments!</h1>
                Set up <strong>at least one</strong> email account with Stax<div className="navigation-logo-dot" />ai so the bots can sort your email attachments.
                <br /><br /><br />
                <img
                    style={{ width: 400 }}
                    src="https://static.stax.ai/images/graphics/guide-email.png"
                    alt="Email intercepting"
                /><br /><br />
                Make sure you have already <strong>created your stacks</strong> and <strong>trained your classifiers</strong> first so the bots know how to sort your email attachments. Else, they will go into the <strong>Unclassified</strong> quick-access stack and you will have to move them yourself!
                <br />
                <div className="welcome-next" onClick={this.props.close}>Got it!</div>
            </> : ""}
        </div>);
    }

};